<template>
	<div class="insideBody">
		<div class="infimgList">
			<img src="../../assets/images/cqt1.jpg" />
			<img src="../../assets/images/cqt2.jpg" />
		</div>
	</div>
</template>
<script>
export default {
  data(){
    return {
			height: null
		};
	},
	created(){
	},
	methods:{
	},
	mounted(){
	},
	components: {
		
	},
}
</script>
<style scoped>
	
</style>